import { Box, BoxProps, Icon, LoaderNew, Spacer, TextNewProps } from '@jfs/ui-new'
import { useFocusEffect } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { ListNew } from '../../components/ListNew'
import { useLazyApiData, useStores } from '../../data/store'
import { MessageTypes } from '../../utils'

export const EntityConfigurationApproval = () => {
  const { getEntityConfigApprovalsAsync, setMessage } = useStores((store) => ({
    getEntityConfigApprovalsAsync: store.entityMaster.getEntityConfigApprovalsAsync,
    setMessage: store.message.setMessage,
  }))
  const [lazyGetEntityConfigApprovals, { data, state }] = useLazyApiData(getEntityConfigApprovalsAsync)

  const [isExpanded, setisExpanded] = useState<{ isExpanded: boolean; value: number; entityConfigData: any }>({
    isExpanded: false,
    value: -1,
    entityConfigData: undefined,
  })

  useFocusEffect(
    useCallback(() => {
      lazyGetEntityConfigApprovals({ pageNumber: 0, pageSize: 10 })
    }, [lazyGetEntityConfigApprovals]),
  )

  const onDismiss = useCallback(() => {
    setisExpanded({ ...isExpanded, isExpanded: false, value: -1 })
  }, [isExpanded])

  const onEntityApprovalAction = useCallback(() => {
    onDismiss()
    lazyGetEntityConfigApprovals({ pageNumber: data?.pageNumber, pageSize: data?.pageSize })
  }, [data?.pageNumber, data?.pageSize, lazyGetEntityConfigApprovals, onDismiss])

  const fetchDataFromServer = useCallback(
    (searchData, paginationInfo) => {
      console.log('data-paginationInfo', searchData, paginationInfo)
      lazyGetEntityConfigApprovals({ pageSize: paginationInfo?.size, pageNumber: paginationInfo?.page - 1 })
    },
    [lazyGetEntityConfigApprovals],
  )

  const getExpandView = () => {
    return (
      <EntityConfigExpandView
        onDismiss={onDismiss}
        entityConfigData={isExpanded?.entityConfigData}
        onEntityApprovalAction={onEntityApprovalAction}
      />
    )
  }

  const onRowItemClick = useCallback(
    ({ item }: any) => {
      console.log('handleOnPress', item)
      setisExpanded({
        isExpanded: !isExpanded.isExpanded,
        value: isExpanded.value === item?.id ? -1 : item?.id,
        entityConfigData: item,
      })
    },
    [isExpanded.isExpanded, isExpanded.value],
  )

  const onDownload = (item) => {
    if (!Array.isArray(item?.value)) {
      setMessage('Data is invalid', MessageTypes.ERROR)
    }
    const downloadValue = item?.value?.map((config) => {
      try {
        return JSON.parse(config)
      } catch (e) {
        return config
      }
    })

    const blob = new Blob([JSON.stringify(downloadValue)], {
      type: 'application/json',
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = item?.processingEntityId + '_' + item?.configType + '_entity_configuration.json'
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
    setMessage('File downloaded sucessfully', MessageTypes.SUCCESS)
  }

  return (
    <>
      <ListNew
        searchData={[]}
        updatedPaginationInfo={{
          ...(data?.pageNumber !== undefined && { page: data?.pageNumber + 1 }),
          ...(data?.totalItems !== undefined && {
            total: data?.totalItems,
          }),
        }}
        type="SCROLLABLE"
        isSearchButtonLoading={state === 'pending'}
        apiHandler={{ state, data }}
        fetchDataFromServer={fetchDataFromServer}
        onRowItemClick={onRowItemClick}
        keyExtractor={keyExtractor}
        headTitle={headTitles}
        sizeConfig={[2.5, 2.5, 2.5, 2.5]}
        data={data?.processInstances}
        showExpandArrow={true}
        expandView={getExpandView}
        isExpanded={isExpanded.isExpanded}
        expandedIndex={isExpanded.value}
        columnsWidth={() => 200}
        onAction={onDownload}
      />
    </>
  )
}

const keyExtractor = (item: any): string => {
  return '' + item.processInstanceId
}

const headTitles = [
  { workflowId: 'ID' },
  { processingEntityId: 'Processor' },
  { configType: 'ConfigType' },
  { downloadEntityConfig: 'Download' },
  { state: 'State' },
  { maker: 'Maker' },
]

const EntityConfigExpandView = ({ onDismiss, entityConfigData, onEntityApprovalAction }: any) => {
  const { entityConfigApprovalActionAsync, setMessage } = useStores((store) => ({
    entityConfigApprovalActionAsync: store.entityMaster.entityConfigApprovalActionAsync,
    setMessage: store.message.setMessage,
  }))
  const [lazyApproveEntity, approveEntityHandler] = useLazyApiData(entityConfigApprovalActionAsync)
  const [lazyRejectEntity, rejectEntityHandler] = useLazyApiData(entityConfigApprovalActionAsync)

  const isLoading = approveEntityHandler.state === 'pending' || rejectEntityHandler?.state === 'pending'

  useEffect(() => {
    if (approveEntityHandler?.state === 'fulfilled' || rejectEntityHandler?.state === 'fulfilled') {
      onEntityApprovalAction()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approveEntityHandler?.state, rejectEntityHandler?.state])

  const internalAction = (taskInstanceId: any, action: string) => {
    if (!taskInstanceId) {
      setMessage('Application in process. Please refresh approval list', MessageTypes.ERROR)
      return
    }
    if (action === 'APPROVE') {
      lazyApproveEntity(taskInstanceId, action)
    } else {
      lazyRejectEntity(taskInstanceId, action)
    }
  }

  return (
    <Box onPress={onDismiss} w={'100%'} underlayColor="TRANSPARENT">
      <Box alignSelf="flex-start" w={'100%'} backgroundColor={'BACKGROUND'} p={24}>
        <Box {...styles.approvalWrapper}>
          <Box
            {...styles.roundedAction({ isActive: true })}
            disabled={isLoading}
            onPress={() => internalAction(entityConfigData?.taskInstanceId, 'APPROVE')}>
            {approveEntityHandler.state !== 'pending' && <Icon id="TICKMARK" size={20} color="WHITE" />}
            {approveEntityHandler.state === 'pending' && <LoaderNew color="WHITE" type={'small'} />}
          </Box>
          <Spacer direction="horizontal" size={40} />
          <Box
            {...styles.roundedAction({ isActive: false })}
            disabled={isLoading}
            onPress={() => internalAction(entityConfigData?.taskInstanceId, 'REJECT')}>
            {rejectEntityHandler.state !== 'pending' && <Icon id="CLOSE" size={20} color="WHITE" />}
            {rejectEntityHandler.state === 'pending' && <LoaderNew color="WHITE" type={'small'} />}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  title: {
    fontSize: 14,
    fontFamily: 'jiotype-bold',
  } as TextNewProps,
  description: {
    fontSize: 12,
    fontFamily: 'jiotype-medium',
    color: '#757575' as any,
    lineHeight: 18,
  } as TextNewProps,
  roundedAction: ({ isActive }: ActionButtonInterface) =>
    ({
      p: 10,
      bg: isActive ? 'GREEN' : 'RED',
      borderRadius: 6,
      underlayColor: isActive ? 'BRAND_PRIMARY_GREEN' : 'ERROR',
    } as BoxProps),
  approvalWrapper: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    ph: 'BIG',
    pv: 20,
  } as BoxProps,
}
